<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes" :showFooter="showFooter">
    <p>Elige las columnas que deseas mostrar en la exporatación de datos.</p>
    <form @submit.prevent="submit()" autocomplete="off">
      <div class="row mb-3">
        <div class="col-12 col-lg-3">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="documentNumber" v-model.trim.lazy="documentNumber">
            <label class="custom-control-label" for="documentNumber">DNI</label>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="name" v-model.trim.lazy="name">
            <label class="custom-control-label" for="name">Nombre</label>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="surnames" v-model.trim.lazy="surnames">
            <label class="custom-control-label" for="surnames">Apellidos</label>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="email" v-model.trim.lazy="email">
            <label class="custom-control-label" for="email">Email</label>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12 col-lg-3">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="fixPhone" v-model.trim.lazy="fixPhone">
            <label class="custom-control-label" for="fixPhone">Fijo</label>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="phone" v-model.trim.lazy="phone">
            <label class="custom-control-label" for="phone">Móvil</label>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="createdDate" v-model.trim.lazy="createdDate">
            <label class="custom-control-label" for="createdDate">Fecha</label>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="city" v-model.trim.lazy="city">
            <label class="custom-control-label" for="city">Localidad</label>
          </div>
        </div>
      </div>
      <div class="row mb-5">
        <div class="col-12 col-lg-3">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="postalCode" v-model.trim.lazy="postalCode">
            <label class="custom-control-label" for="postalCode">Código Postal</label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="row mb-2" @click="openAdditionalDataFunc()">
            <div class="col-12">
              <h6 class="float-left mr-3">Campos adicionales</h6>
              <v-icon v-if="!openAdditionalData" name="hi-solid-chevron-down" scale="1.1" />
              <v-icon v-if="openAdditionalData" name="fa-chevron-up" scale="1.2" />
            </div>
          </div>
          <div class="row mb-3" v-if="openAdditionalData">
            <div class="col-12 col-lg-3">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="street" v-model.trim.lazy="street">
                <label class="custom-control-label" for="street">Dirección</label>
              </div>
            </div>
            <div class="col-12 col-lg-3">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="province" v-model.trim.lazy="province">
                <label class="custom-control-label" for="province">Provincia</label>
              </div>
            </div>
            <div class="col-12 col-lg-3">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="tracking" v-model.trim.lazy="tracking">
                <label class="custom-control-label" for="tracking">Tracking</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3 pt-3 pl-0">
        <div class="col-12">
          <button class="btn generalSecondaryButton float-left" data-dismiss="modal">Cerrar</button>
          <button class="btn btn-primary generalPrimaryButton float-right">Exportar</button>
        </div>
      </div>
    </form>
  </Modal>
</template>

<script>
import axios from 'axios';
import Modal from '../../../Shared/Modal.vue';

export default {
  name: 'ExportData',
  props: [
    'id',
    'modalTitle',
    'class',
    'showFooter',
    'filters',
    'order',
  ],
  data() {
    return {
      classes: this.class,
      documentNumber: true,
      name: true,
      surnames: true,
      email: true,
      fixPhone: true,
      phone: true,
      createdDate: true,
      city: true,
      postalCode: true,
      openAdditionalData: false,
      street: false,
      province: false,
      tracking: false,
    };
  },
  components: {
    Modal,
  },
  methods: {
    openAdditionalDataFunc() {
      this.openAdditionalData = !this.openAdditionalData;
    },
    submit() {
      const bodyToSend = {
        filters: [],
        order: 'ASC',
        columns: []
      }
      //Cambiar por la integracion del servicio final cuando este
      axios.post('https://modyo.vass.es/ok', bodyToSend)
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
